<!--
Current Signing Modal component is !ONLY for login purpose
for normal signing, please use ecounter signing
-->

<template>
  <b-modal
    size="xl"
    modal-class="bd-modal"
    v-model="localValue"
    hide-footer
    @hidden="reset"
    no-close-on-backdrop
    @show="$root.$emit('app:unload-prompt', true)"
  >
    <NxBWizard
      content-class="mt-3"
      align="center"
      class="mb-4"
      v-model="step"
      lazy
      pills
      vertical
      ref="wizard"
    >
      <!-- <NxBWizardStep title="Digest"> -->
        

      <NxBWizardStep :title="$t('SignMethod')">
        <NxSigningModalMethod v-model="source" v-on="stepActions" />
      </NxBWizardStep>

      <NxBWizardStep  :title="$t('Digest')">
        <NxSigningModalDigest v-model="source" v-on="stepActions" />
      </NxBWizardStep>

      <NxBWizardStep :title="$t('ConnectSigningAgent')">
        <NxSigningModalMethodP12Batch
          v-model="source"
          v-if="source.signMethod === 'SIGN_P12'"
          v-on="stepActions"
        />
        <NxSigningModalMethodTokenBatch
          v-model="source"
          v-else-if="source.signMethod === 'SIGN_TOKEN'"
          v-on="stepActions"
        />
        <NxSigningModalMethodIAMSmartBatch
          v-model="source"
          v-else-if="source.signMethod === 'SIGN_IAM_SMART'"
          v-on="stepActions"
        />
        <div v-else>
          <b-alert show variant="danger">Undefined sign method</b-alert>
        </div>
      </NxBWizardStep>

      <NxBWizardStep :title="$t('MergeDocument')" >
        <!-- <NxSigningModalMergeDoc v-model="source" v-on="stepActions" :is-non-pdf="isNonPdf" :file-id="fileId" :is-drawing="isDrawing" /> -->
        <NxSigningModalMergeDocBatch 
          :username="username"
          :password="password"
        v-model="source" v-on="stepActions" />
      </NxBWizardStep>

      <NxBWizardStep  :title="$t('SignCompleted')" :hide-step="step === failStep">
        <NxSigningModalComplete
          v-model="source"
          v-on="stepActions"
          @signComplete="signComplete()"
        />
      </NxBWizardStep>

      <NxBWizardStep :title="$t('SignFail')" :hide-step="step !== failStep">
        <NxSigningModalFailure v-model="source" v-on="stepActions" />
      </NxBWizardStep>
    </NxBWizard>
  </b-modal>
</template>

<script>
import { NxBWizard, NxBWizardStep } from '@nextore/nx-b-wizard';
import { BModal, BAlert } from 'bootstrap-vue';
import NxSigningModalInit from './NxSigningModalInit';
import NxSigningModalMethod from './NxSigningModalMethod';
import NxSigningModalMethodP12 from './NxSigningModalMethodP12';
import NxSigningModalMethodToken from './NxSigningModalMethodToken';
import NxSigningModalComplete from './NxSigningModalComplete';
import NxSigningModalMergeDoc from './NxSigningModalMergeDoc';
import NxSigningModalSignature from './NxSigningModalSignature';
import NxSigningModalField from './NxSigningModalField';
import NxSigningModalDigest from './NxSigningModalDigest';
import NxSigningModalFailure from './NxSigningModalFailure';
import NxSigningModalMethodIAMSmart from './NxSigningModalMethodIAMSmart';
import NxSigningModalMethodP12Batch from './NxSigningModalMethodP12Batch';
import NxSigningModalMethodTokenBatch from './NxSigningModalMethodTokenBatch';
import NxSigningModalMethodIAMSmartBatch from './NxSigningModalMethodIAMSmartBatch';
import NxSigningModalMergeDocBatch from './NxSigningModalMergeDocBatch';

export default {
  components: {
    BModal,
    BAlert,
    NxBWizard,
    NxBWizardStep,
    NxSigningModalInit,
    NxSigningModalMethod,
    NxSigningModalMethodP12,
    NxSigningModalMethodToken,
    NxSigningModalComplete,
    NxSigningModalMergeDoc,
    NxSigningModalSignature,
    NxSigningModalField,
    NxSigningModalDigest,
    NxSigningModalFailure,
    NxSigningModalMethodIAMSmart,
    NxSigningModalMethodP12Batch,
    NxSigningModalMethodTokenBatch,
    NxSigningModalMethodIAMSmartBatch,
    NxSigningModalMergeDocBatch
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    username:"",
    password:"",
    // fileId: {}
    files: {
      type: Array
    },
    guid:{
      type: String
    },
    isRegistration: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      source: this.getInitSource(),
      step: 0
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    failStep() {
      // console.log('this.source.signmethod', this.source.signMethod)
      return this.source.SignMethod === 'SIGN_IAM_SMART'?4:5;
    },
    stepActions() {
      if(this.isRegistration){
        return { next: this.next, fail: () => this.next(6) };//fail step 
      }else{
        return { next: this.next, fail: () => this.next(5) };//fail step 
      }
     
    }
  },
  watch: {
    files: {
      handler(files) {
        this.source = { ...this.source, files };
      },
      immediate: true
    }
  },
  methods: {
    reset() {
      this.source = this.getInitSource();
      this.step = 0;
    },
    getInitSource() {
      return {
        guid:this.guid,
        signInfo: null,
        field: null,
        digest: null,
        signature: null,
        files: this.files,
        signMethod: null,
        folderName: this.folderName
      };
    },
    next(step) {
      if (step !== undefined) {
        this.step = step;
      } else {
        this.step++;
      }
    },
    signComplete() {
      this.$emit('signComplete');
    }
  },  i18n: {
    messages: {
      en: {
        Digest: 'Digest',
        SignMethod: 'Sign Method',
        ConnectSigningAgent: 'Connect to signing agent',
        MergeDocument: 'Merge document',
        SignCompleted: 'Sign completed',
        SignFail: 'Sign Fail'
      },
      zh_hk: {
        Digest: '文摘',
        SignMethod: '簽名方法',
        ConnectSigningAgent: '連接到簽名代理',
        MergeDocument: '合併文檔',
        SignCompleted: '簽名完成',
        SignFail: '簽署失敗'
      },
      zh_cn: {
        Digest: '文摘',
        SignMethod: '签名方法',
        ConnectSigningAgent: '连接到签名代理',
        MergeDocument: '合并文档',
        SignCompleted: '签名完成',
        SignFail: '签署失败'
      }
    }
  }
};
</script>

<style>
@import '~vue-form-wizard/dist/vue-form-wizard.min.css';
</style>
